export const OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM = 'openSubscribeDrawer';
export const REMOVE_SUBSCRIPTION_MODAL_TITLE = 'Remove subscription?';
export const REMOVE_SUBSCRIPTION_MODAL_DESCRIPTION =
  "You are about to remove the subscription. You'll not be able to get updates, if you proceed.";
